import type { CreateClientConfig } from "./src/dashboard-client/client.gen";

export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  credentials: "include",
});
